// === ZAES STORE — Add to Cart Overlay Script ===
document.addEventListener("DOMContentLoaded", () => {
  console.log("🛒 ZAES overlay script loaded");

  // Detectar envío de formularios mini de producto
  document.querySelectorAll("product-form").forEach((formWrapper) => {
    const form = formWrapper.querySelector("form");
    if (!form) return;

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const formData = new FormData(form);

      try {
        // Enviar a Shopify cart AJAX
        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        console.log("✅ Producto agregado:", data);

        // Abrir el mini carrito lateral
        const drawer = document.querySelector(".zk-cart-overlay, .cart-drawer");
        if (drawer) {
          drawer.classList.add("is-active");
          document.body.classList.add("cart-open");
        } else {
          console.log("⚠️ Drawer no encontrado");
        }

      } catch (error) {
        console.error("❌ Error al agregar al carrito:", error);
      }
    });
  });
});
